export { HistoryCalendar } from './HistoryCalendar';
export { default as HistoryHeader } from './HistoryHeader';
export { HistoryActivitySection } from './HistoryActivitySection';
export { default as GeneralHistoryHeader } from './GeneralHistoryHeader';
export type { TabType } from './GeneralHistoryHeader';
export { PatientDocumentsSection } from './PatientDocumentsSection';
export { default as HistoryVisitsSection } from './HistoryVisitsSection';
export { VisitsPeriodSection } from './VisitsPeriodSection';

export * from './documents';
export * from './filters';
export * from './reports';
